import { GridColDef } from '@mui/x-data-grid';
import { DataGridPremium, DataGridPremiumProps } from '@mui/x-data-grid-premium';
import { getDataGridLocalization, MgPrisLocale } from '@retail/utils';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props<T> extends DataGridPremiumProps {
  rows: T[];
  columns: GridColDef[];
}

const CustomDataGrid = <T,>({ rows, columns, ...rest }: Props<T>) => {
  const {
    i18n: { language },
  } = useTranslation();

  return (
    <Box sx={{ flexGrow: 1, position: 'relative' }}>
      <Box sx={{ position: 'absolute', inset: 0 }}>
        <DataGridPremium
          {...rest}
          rows={rows}
          columns={columns}
          localeText={getDataGridLocalization(language as MgPrisLocale)}
          disableColumnReorder={rest.disableColumnReorder ?? true}
        />
      </Box>
    </Box>
  );
};

export default CustomDataGrid;
